import React from "react";
import "./homeheadercards.css"
import {ContainerComponent} from "../../../app/components/container/ContainerComponent";
import {Link} from "react-router-dom";
import {trackClick} from "../../../app/utils/Analytics";

export default function HomeHeaderCardsComponent({children}) {
    return (
        <ContainerComponent>
            <div className={"homeHeaderCards"}>
                {children}
            </div>
        </ContainerComponent>
    );
}

export function HomeHeaderCard({icon, title, color, link}) {
    return (
        <Link className={"homeHeaderCard " + color} to={link} onClick={() => {
            trackClick("HomeHeaderCard -", link)
        }}>
            {icon}
            <span>{title}</span>
        </Link>
    )
}
